<template>
  <div class="trbo-a-no-products">
    <div class="trbo-a-no-products__text">
      <p class="trbo-a-no-products__text__description">{{ $t('wizard.noRecommendationDescription') }}</p>
      <p class="trbo-a-no-products__text__description"><em>{{ $t('wizard.noRecommendationDescription2') }}</em></p>
    </div>
    <div class="trbo-a-no-products__action">
      <button class="trbo-a-question-next-button" @click="$emit('restart')">
        <div class="trbo-a-question-next-button__wrapper">
          <icon name="next" class="trbo-a-question-next-button__icon" />
          <div class="trbo-a-question-next-button__title">
            {{ $t('wizard.noRecommendationRestartButtonTitle') }}
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
// @flow

import Icon from '../../Icon/Icon.vue'

export default {
  components: {
    Icon
  }
}
</script>

<style scoped src="../NextButton/next-button.scss" />

<style src="./no-products.scss" />
